<template>
  <span
    class="navrh-abbr-tip"
    :class="{'navrh-abbr-tip--inline': inlineLabel}"
  >
    <v-tooltip
      top
      open-on-click
    >
      <template #activator="{ on, attrs }">
        <span
          class="navrh-abbr-tip__label"
          tabindex="0"
          role="button"
          v-bind="attrs"
          v-on="on"
        >{{ label }}</span>
      </template>
      <span>{{ text }}</span>
    </v-tooltip>
    <v-tooltip
      top
      open-on-click
    >
      <template #activator="{ on, attrs }">
        <v-icon
          x-small
          class="navrh-abbr-tip__icon"
          tabindex="0"
          role="button"
          aria-label="Nápověda"
          v-bind="attrs"
          v-on="on"
        >
          info_outline
        </v-icon>
      </template>
      <span>{{ text }}</span>
    </v-tooltip>
  </span>
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        name: 'WorkspaceAbbrTip',
        props: {
            label: {type: String, required: true},
            text: {type: String, required: true},
            inlineLabel: {type: Boolean, default: false},
        },
    });
</script>

<style scoped lang="sass">
.navrh-abbr-tip
    display: inline-flex
    align-items: center
    vertical-align: middle
    gap: 2px

.navrh-abbr-tip__label
    color: var(--sw-primary-fill)
    cursor: help
    text-decoration: underline dotted
    text-underline-offset: 2px

.navrh-abbr-tip--inline .navrh-abbr-tip__label
    text-decoration: none
    font-weight: inherit

.navrh-abbr-tip__icon
    opacity: .75
    cursor: pointer
</style>
